/* cert/actions */
import { action } from "typesafe-actions";
import { Cert, CertActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(CertActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: Cert) =>
  action(CertActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(CertActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: Data,
  query?: string,
  callback?: (err: string | null, data: Cert | null) => unknown
) => action(CertActionTypes.SAVE_REQUEST, { data, query, callback });

export const saveSuccess = (data: Cert) =>
  action(CertActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(CertActionTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id: string,
  callback?: (error: string | null) => unknown
) => action(CertActionTypes.DELETE_REQUEST, { id, callback });

export const deleteSuccess = () => action(CertActionTypes.DELETE_SUCCESS);

export const deleteError = (error: string) =>
  action(CertActionTypes.DELETE_ERROR, error);
